var jlApplicants = function(elementID,hashKey,listingTitle=""){

  this.filters = {
    'all':'All Applicants',
    'unread':'Unread Applicants',
    'read':'Read Applicants',
  };

  this.elementID = elementID;
  this.element = document.getElementById(elementID);
  this.hashKey = hashKey;
  this.focusApplicant = ""; 
  this.listingTitle = "";
  this.sort = "all";


  if(hh2020Login.userData.id && hh2020Login.userData.token){
    this.load();
  }


}

jlApplicants.prototype.load = function(){

  this.element.classList.add("jlApplicants");
  this.applicantContent = document.createElement("div");
  this.applicantContent.setAttribute("id","applicantContent");

  this.applicantMenu = document.createElement("div");
  this.applicantMenu.classList.add("applicantMenu");

  this.element.append(this.applicantMenu);
  this.element.append(this.applicantContent);

  this.messageHolder = document.createElement("div");
  this.messageHolder.classList.add("message");
  this.applicantMenu.append(this.messageHolder);


  this.loadFilters();
  this.loadApplicants();



};

jlApplicants.prototype.message = function(message){
  var self = this;
  if(this.messageTimer){
    clearTimeout(this.messageTimer);
  }

  self.messageHolder.classList.add("show");
  self.messageHolder.innerHTML = message;

  if(window.innerWidth < 601){

    var contentOffset = this.element.getBoundingClientRect();
    window.scrollTo({top:contentOffset.top + window.scrollY - 250,behavior:"smooth"});

  }

  this.messageTimer = setTimeout(function(){
    self.messageHolder.classList.remove("show");
  },5000);


};

jlApplicants.prototype.loadFilters = function(){
  var self = this;


  var select = document.createElement("select");
  for(let f of Object.keys(self.filters)){
    var option = document.createElement("option");
    option.value = f;
    option.innerText = self.filters[f];
    select.append(option);
  }

  select.addEventListener("change",(e)=>{
    self.sort = e.currentTarget.value;
    var sortedData = self.sortApplicants(self.applicants);
    self.renderApplicants(sortedData);

  });

  this.applicantMenu.append(select);


};

jlApplicants.prototype.sortApplicants = function(data,filter=false){
  var self = this;
  if(!filter){
    this.sortCount(data);
  }
  var filterKey = filter || self.sort;
  console.log("SORT APPLICANTS");

  if(!data){
    return false;
  }
  console.log(data);
  data = data.filter((a)=>{
    if(filterKey == "all"){

      return true;
    }
    else if(filterKey == "unread"){
      return a.read ? false : true;
    }
    else if(filterKey == "read"){
      return a.read;
    }
    else{
      return true;
    }
  });
  console.log(data);
  return data;

};

jlApplicants.prototype.sortCount = function(data){
  var self = this;
  console.log("FILTER DATA COUNT");
  for(let f of Object.keys(self.filters)){

    var fData = self.sortApplicants(data,f);
    var options = self.element.querySelectorAll("option[value='"+f+"']");
    for(let o of options){
      if(!fData){
        fData = [];
      }
      o.innerText = self.filters[f] + " ("+fData.length+")";
    }
  }
};


jlApplicants.prototype.loadApplicants = function(){
  var self = this;

  this.applicantList = this.applicantList || document.createElement("ul");
  this.applicantList.innerHTML = "";
  this.applicantList.setAttribute("id","applicantList");


  var listLoader = document.createElement("li");
  listLoader.classList.add("loader");
  listLoader.innerHTML = "Loading Applicants...";
  this.applicantList.append(listLoader);
  this.applicantMenu.append(this.applicantList);

  fetch(JLAJAX.url + "applicants/"+this.hashKey,{
    method:"POST",
    headers:{
      'Content-Type':'application/json',
      'Accept':'application/json'
    },
    body:JSON.stringify({
      id:hh2020Login.userData.id,
      token:hh2020Login.userData.token
    })
  }).then(res=>res.json())
  .then(data=>{
    //console.log("DATA HREFE");
    listLoader.remove();
    if(data.length == 0){
      //self.applicantList.innerHTML = "<div>No Applicants</div>";
      //self.element.classList.add("noApplicants");
    }
    console.log(data);
    self.applicants = data;
    self.sortCount(data);
    self.renderApplicants();

  });


};

jlApplicants.prototype.renderApplicants = function(data){
  var self = this;
    if(!data){
      data = self.applicants;
    }
    if(!data){
      return false;
    }
    this.applicantList.innerHTML = "";


      for(let a of data){
        var item = document.createElement("li");
        var link = document.createElement("a");
        if(a.applicantHash == self.focusApplicant){
          link.classList.add("focus");
        }


        link.setAttribute("href",JLAJAX.homeURL+"applicants/"+this.hashKey+"/"+a.applicantHash);
        link.setAttribute("data-applicantKey",a.applicantHash);
        var email = a.from.replace("<","&lt;");
        link.innerHTML = "<i data-format='datetime' data-timestamp='"+a.date+"'></i><b>"+email+"</b>"+a.subject;
        item.append(link);

        if(a.read){
          item.classList.add("read");
        }


        link.addEventListener("click",(e)=>{
          e.preventDefault();



          self.loadApplicant(e.currentTarget.getAttribute("data-applicantKey"));
        });
        self.applicantList.append(item);
      }

      jlDate();
};




jlApplicants.prototype.loadApplicant = function(applicantKey){
    var self = this;
    this.applicantLoading();
    this.focusApplicant = applicantKey;
    window.history.pushState({}, this.listingTitle + " : Applicants", JLAJAX.homeURL + "applicants/"+this.hashKey+"/"+applicantKey);

    var i  = 0;
    if(this.applicants){
      while(this.applicants[i]){
        if(this.applicants[i].applicantHash == applicantKey){
          this.applicants[i].read = true;
        }
        i++;
      }
    }

    var sortedData = this.sortApplicants(this.applicants);
    this.renderApplicants(sortedData);

    if(window.innerWidth < 601){

      var contentOffset = this.applicantContent.getBoundingClientRect();
      window.scrollTo({top:contentOffset.top + window.scrollY - 250,behavior:"smooth"});

    }

    var focusApplicant = this.applicantList.getElementsByClassName("focus");
    if(focusApplicant && focusApplicant[0]){
      focusApplicant[0].classList.remove("focus");
    }

    var applicantLink = this.applicantList.querySelector("[data-applicantKey='"+applicantKey+"']");

    if(applicantLink){
      applicantLink.parentNode.classList.add("read");
      applicantLink.classList.add("focus");
    }

    fetch(JLAJAX.url + "applicants/"+this.hashKey+"/"+applicantKey,{
      method:"POST",
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        id:hh2020Login.userData.id,
        token:hh2020Login.userData.token
      })
    }).then(res=>res.json())
    .then(data=>{
      self.showApplicant(data);
    });
};

jlApplicants.prototype.markUnread = function(applicantKey){
    var applicantLink = this.applicantList.querySelector("[data-applicantKey='"+applicantKey+"']");

    if(applicantLink){
      applicantLink.parentNode.classList.remove("read");
    }

    var i =0;

    while(this.applicants[i]){
      if(this.applicants[i].applicantHash == applicantKey){
        this.applicants[i].read = false;
      }
      i++;
    }
    var sortedData = this.sortApplicants(this.applicants);
    this.renderApplicants(sortedData);
    this.message("Applicant Marked Unread");

    fetch(JLAJAX.url + "applicants/"+this.hashKey+"/"+applicantKey+"/unread",{
      method:"POST",
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        id:hh2020Login.userData.id,
        token:hh2020Login.userData.token
      })
    }).then(res=>res.json())
    .then(data=>{   });
};


jlApplicants.prototype.delete = function(applicantKey){
  if(confirm("Are you sure you want to delete this applicant? (Deletions are permanent)")){
    var applicantLink = this.applicantList.querySelector("[data-applicantKey='"+applicantKey+"']");

    if(applicantLink){
      applicantLink.parentNode.remove();
    }

    this.applicantContent.innerHTML = "";
    this.message("Applicant Deleted");

    fetch(JLAJAX.url + "applicants/"+this.hashKey+"/"+applicantKey+"/delete",{
      method:"POST",
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        id:hh2020Login.userData.id,
        token:hh2020Login.userData.token
      })
    }).then(res=>res.json())
    .then(data=>{   });
  }
};

jlApplicants.prototype.applicantLoading = function(){
  this.applicantContent.innerHTML = "LOADING...";
};

jlApplicants.prototype.renderButton = function(text,callback,icon=false){
  var button = document.createElement("a");
  button.setAttribute("href","#");
  if(icon){
    button.innerHTML = jlIcons[icon] + " " + text;
  }
  else{
    button.innerHTML = text;
  }
  button.classList.add("jlButton");
  button.addEventListener("click",function(e){
    e.preventDefault();
    callback(e);
  });

  return button;

};

jlApplicants.prototype.showApplicant = function(data){
  var self = this;

  this.applicantContent.innerHTML = "";


  var controls = document.createElement("div");
  controls.classList.add("controls");


  controls.append(this.renderButton("Reply",(e)=>{
    parent.location = "mailto:"+data.from;

  },'reply'));
  controls.append(this.renderButton("Mark Unread",(e)=>{
    self.markUnread(data.applicantHash);
    e.currentTarget.style.display = "none";
  },'unread'));
  controls.append(this.renderButton("Delete",(e)=>{
    self.delete(data.applicantHash);
  },'trash'));

  this.applicantContent.append(controls);


  var email = data.from.replace("<","&lt;");
  this.applicantContent.append(this.renderLine("Applicant","<a href='mailto:"+email+"'>"+email+"</a>"));
  this.applicantContent.append(this.renderLine("Date Submitted","<div data-format='datetime' data-timestamp='"+data.date+"'></div>"));
  this.applicantContent.append(this.renderLine("Subject",data.subject));

  var message = document.createElement("p");
  message.innerHTML = data.message;
  this.applicantContent.append(message);

  var attachmentList = document.createElement("ul");
  attachmentList.classList.add("attachmentList");

  for(let a of data.attachments){
    var item = document.createElement("li");
    var link = document.createElement("a");
    link.innerHTML = jlIcons['file'] + " " + a;
    link.setAttribute("href","https://media.hubhawaii.com/applicants/"+data.applicantHash+"/"+a);
    item.append(link);
    attachmentList.append(item);
  }

  this.applicantContent.append(attachmentList);


  jlDate();


};

jlApplicants.prototype.renderLine = function(key,value){
  var line = document.createElement("div");
  line.classList.add("line");
  line.innerHTML = "<b>"+key+"</b>"+value;
  return line;


};
